<template>
  <div class="flex space-x-16 2xl:text-4xl text-3xl slit-in-diagonal-1 mt-6 justify-center">
    <div>
      <a href="https://www.linkedin.com/in/agnel-giles-627340112/" target="_blank"
        ><i class="fab fa-linkedin text-icon-color hover:text-icon-hover text-4xl"></i
      ></a>
    </div>
    <div>
      <a href="https://github.com/agnelfernando" target="_blank"
        ><i class="fab fa-github-square text-icon-color  hover:text-icon-hover text-4xl"></i
      ></a>
    </div>
  </div>
</template>

<script>
export default {
    name:'VLinks'
};
</script>
